const USER_TOKEN_FIELD = 'userToken'
const USER_BASIC_ID = 'userBasicId'
const AFFILIATE_KEY = 'affiliateKey'

export const getUserToken = () => localStorage.getItem(USER_TOKEN_FIELD)

export const setUserToken = (userToken) => localStorage.setItem(USER_TOKEN_FIELD, userToken)

export const removeUserToken = () => localStorage.removeItem(USER_TOKEN_FIELD)

const KPAYMENT_CHECKOUT_VALUE = 'KPAYMENT_CHECKOUT_VALUE'

export const getKPaymentCheckout = () => localStorage.getItem(KPAYMENT_CHECKOUT_VALUE)

export const setKPaymentCheckout = (checkoutVal) => {
  localStorage.setItem(KPAYMENT_CHECKOUT_VALUE, JSON.stringify(checkoutVal))
}

export const removeKPaymentCheckout = () => localStorage.removeItem(KPAYMENT_CHECKOUT_VALUE)

const KPAYMENT_CHARGE_ID = 'KPAYMENT_CHARGE_ID'

export const getKPaymentChargeId = () => localStorage.getItem(KPAYMENT_CHARGE_ID)

export const setKPaymentChargeId = (id) => localStorage.setItem(KPAYMENT_CHARGE_ID, id)

export const removeKPaymentChargeId = () => localStorage.removeItem(KPAYMENT_CHARGE_ID)

const KPAYMENT_USER_SAVE_CARD = 'KPAYMENT_USER_SAVE_CARD'

export const getKPaymentUserSaveCard = () => localStorage.getItem(KPAYMENT_USER_SAVE_CARD)

export const setKPaymentUserSaveCard = (string) => {
  localStorage.setItem(KPAYMENT_USER_SAVE_CARD, string)
}

export const removeKPaymentUserSaveCard = () => localStorage.removeItem(KPAYMENT_USER_SAVE_CARD)

export const persistAffiliateKey = (affiliateKey) => {
  localStorage.setItem(AFFILIATE_KEY, affiliateKey)
}

export const getAffiliateKey = () => localStorage.getItem(AFFILIATE_KEY)

export const clearAffiliateKey = () => {
  localStorage.removeItem(AFFILIATE_KEY)
}

export const getUserBasicId = () => localStorage.getItem(USER_BASIC_ID)

export const setUserBasicId = (basicId) => localStorage.setItem(USER_BASIC_ID, basicId)

export const removeUserBasicId = () => localStorage.removeItem(USER_BASIC_ID)
